"use client";

import { TableRow, TableCell } from "@oreme/ui";
import { Hexagon, Triangle, Circle } from "lucide-react";
import { useTranslations } from "next-intl";
import React, { type HTMLAttributes, type ReactElement } from "react";
import { Site, SiteTypeEnum } from "@/types";

interface SiteTableRowProps extends HTMLAttributes<HTMLDivElement> {
  site: Site;
}

function SiteTableRow({ site }: Readonly<SiteTableRowProps>): ReactElement {
  const t = useTranslations("global.SiteTable");
  let icon;
  switch (site.type) {
    case SiteTypeEnum.ZONE:
      icon = <Hexagon className="shrink-0" size={16} />;
      break;
    case SiteTypeEnum.STATION:
      icon = <Triangle className="shrink-0" size={16} />;
      break;
    case SiteTypeEnum.POINT:
    default:
      icon = <Circle className="shrink-0" size={16} />;
      break;
  }

  return (
    <TableRow className="text-xs">
      <TableCell className="py-2">{site.name}</TableCell>
      <TableCell className="py-2">
        {site.region ? `${site.region},` : null} {site.country}
      </TableCell>
      <TableCell className="py-2">
        <span className="inline-flex gap-2">
          {icon}
          {t(`${site.type}.description`)}
        </span>
      </TableCell>
    </TableRow>
  );
}

export { SiteTableRow, type SiteTableRowProps };
